import type { Directive } from 'vue';
import { watch } from 'vue';

import { usePermissionStore } from '@/store/modules/permission';

export const permission: Directive = {
  mounted(el, binding) {
    const permissionStore = usePermissionStore();
    const { value } = binding;

    // 先隐藏元素，而不是删除
    el.style.display = 'none';

    // 等待角色信息加载完成后再判断
    if (permissionStore.allRoleList?.length) {
      handlePermission();
    } else {
      // 监听角色列表变化
      const unwatch = watch(
        () => permissionStore.allRoleList,
        (newVal) => {
          if (newVal?.length) {
            handlePermission();
            unwatch(); // 清理 watch
          }
        },
      );
    }

    function handlePermission() {
      // 如果是管理员，显示元素
      if (permissionStore.isAdmin()) {
        el.style.display = '';
        return;
      }

      // 检查具体权限 -- 包含按钮权限处理， 如果按钮权限都没有，则隐藏元素
      if (value && !permissionStore.hasPermission(value)) {
        el.style.display = 'none';
      } else {
        el.style.display = '';
      }
    }
  },
};
